import { doc, getDoc, serverTimestamp, setDoc } from "firebase/firestore";
import { db } from "../firebase";

/**
 * Persist an FCM/web-push token to the `fcmTokens` collection. Platform-neutral
 * (uses the Firestore SDK, which runs on both web and the native build), so both
 * the web and native push-registration paths write through here. The backend
 * reads this collection to fan a push out to every device a user has registered.
 */
export const setToken = async (
  token: string,
  userId: string,
  platform: "web" | "ios" | "android" = "web",
) => {
  const ref = doc(db, "fcmTokens", token);
  const existing = await getDoc(ref);
  const data: Record<string, unknown> = {
    userId,
    platform,
    updatedAt: serverTimestamp(),
  };
  // `navigator` is polyfilled on native but `navigator.userAgent` is undefined
  // there. Only write the field when it's a real value — Firestore rejects
  // `undefined` field values (setDoc throws "Unsupported field value").
  const userAgent =
    typeof navigator !== "undefined" ? navigator.userAgent : undefined;
  if (userAgent) {
    data.userAgent = userAgent;
  }
  if (!existing.exists()) {
    data.createdAt = serverTimestamp();
  }
  return setDoc(ref, data, { merge: true });
};
